import { createFileRoute } from '@tanstack/react-router'
import PaymentCancelled from '@/components/make-booking/payment/PaymentCancelled'

export const Route = createFileRoute('/make-booking/$id/payment/cancelled')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PaymentCancelled />
}
